/**
 * @desc 批量TheNewAnnualSalesPlan
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<defs.TheNewAnnualSalesPlan>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/sale/indicator/addBatch',
    data,
  });
}

export function mock(
  data: Array<defs.TheNewAnnualSalesPlan>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/sale/indicator/addBatch',
    data,
  });
}
